import { groupsV2Service } from 'config/api';
import actionTypes from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const fetchPrePopulatedGroups = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PRE_POPULATED_GROUPS_LOADING });

  try {
    const res = await groupsV2Service.get('/defaultGroups');
    const groups = Array.isArray(res.data) ? res.data : [];

    dispatch({ type: actionTypes.GET_PRE_POPULATED_GROUPS_SUCCESS, payload: groups });
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({ type: actionTypes.GET_PRE_POPULATED_GROUPS_ERROR, payload: error });
  }
};
